/**
 * ViewIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ViewIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.475 11.594c-3-5.9-10.2-8.3-16.1-5.3-2.3 1.2-4.1 3-5.3 5.3q-.15.45 0 .9c3 5.9 10.2 8.3 16.1 5.3 2.3-1.2 4.1-3 5.3-5.3.1-.3.1-.7 0-.9m-10.7 5.4c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5m0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ViewIcon = makeIcon('ViewIcon', ViewIconSvg)
